import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76dcee27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workspace" }
const _hoisted_2 = { class: "container-fluid workspace__container pt-5" }
const _hoisted_3 = { class: "row justify-content-start" }
const _hoisted_4 = { class: "col-md-12 col-lg-auto offset-0 offset-xxl-2" }
const _hoisted_5 = { class: "col-md-12 col-lg-6" }
const _hoisted_6 = {
  key: 0,
  class: "py-2 mb-2 workspace__container__recent"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-end gap-2 justify-content-start mb-3 workspace__container__recent__title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-star" }),
  /*#__PURE__*/_createElementVNode("span", null, "Starred boards")
], -1))
const _hoisted_8 = { class: "workspace__container__recent_boards d-flex gap-2 flex-wrap justify-content-start my-2" }
const _hoisted_9 = { class: "py-2 mb-2 workspace__container__recent" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-end gap-2 justify-content-start mb-3 workspace__container__recent__title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock" }),
  /*#__PURE__*/_createElementVNode("span", null, "Recently viewed")
], -1))
const _hoisted_11 = { class: "workspace__container__recent_boards d-flex gap-2 flex-wrap justify-content-start my-2" }
const _hoisted_12 = { class: "py-2 mb-4 workspace__container__owner" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-end gap-2 justify-content-start my-4 workspace__container__owner__title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "YOUR WORKSPACES")
], -1))
const _hoisted_14 = { class: "d-flex flex-wrap gap-2 mb-3 align-items-center justify-content-start" }
const _hoisted_15 = { class: "flex-grow-1 w-sm-100" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-kanban" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-table" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Workspace table ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Members ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear" }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_23 = { class: "workspace__container__owner__boardsgrid my-2" }
const _hoisted_24 = { class: "d-flex gap-2 mt-3 flex-wrap justify-content-start my-2" }
const _hoisted_25 = { class: "py-2 mb-4 workspace__container__guest" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2 justify-content-start my-4 workspace__container__guest__title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "GUEST WORKSPACES"),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" })
], -1))
const _hoisted_27 = { class: "d-flex flex-wrap gap-3 justify-content-start my-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_workspace_side_menu = _resolveComponent("workspace-side-menu")!
  const _component_board = _resolveComponent("board")!
  const _component_workspace_title = _resolveComponent("workspace-title")!
  const _component_action_button = _resolveComponent("action-button")!
  const _component_create_new_board = _resolveComponent("create-new-board")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_workspace_side_menu, { class: "d-none d-xl-block" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.starredBoards.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.starredBoards, (b) => {
                    return (_openBlock(), _createBlock(_component_board, {
                      key: b._id,
                      name: b.name,
                      starred: b.starred,
                      onClick: ($event: any) => (_ctx.$router.push({ name: 'kanban', params: { boardId: b._id } }))
                    }, null, 8, ["name", "starred", "onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentBoards, (b) => {
                return (_openBlock(), _createBlock(_component_board, {
                  key: b._id,
                  name: b.name,
                  starred: b.starred,
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'kanban', params: { boardId: b._id } }))
                }, null, 8, ["name", "starred", "onClick"]))
              }), 128))
            ])
          ]),
          _createElementVNode("section", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_workspace_title, {
                  title: "Trello workspaces",
                  "title-styles": { fontSize: '16px' }
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_action_button, null, {
                  prefix: _withCtx(() => [
                    _hoisted_16
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Boards (" + _toDisplayString(_ctx.workspace.createdBoards.length) + ") ", 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_action_button, null, {
                  prefix: _withCtx(() => [
                    _hoisted_17
                  ]),
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_action_button, null, {
                  prefix: _withCtx(() => [
                    _hoisted_19
                  ]),
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_action_button, null, {
                  prefix: _withCtx(() => [
                    _hoisted_21
                  ]),
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspace.createdBoards, (b) => {
                return (_openBlock(), _createBlock(_component_board, {
                  key: b._id,
                  name: b.name,
                  starred: b.starred,
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'kanban', params: { boardId: b._id } }))
                }, null, 8, ["name", "starred", "onClick"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_create_new_board)
            ])
          ]),
          _createElementVNode("section", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspace.invitedBoards, (b) => {
                return (_openBlock(), _createBlock(_component_board, {
                  key: b._id,
                  name: b.name,
                  starred: b.starred,
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'kanban', params: { boardId: b._id } }))
                }, null, 8, ["name", "starred", "onClick"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}